
import * as ACTIONS from '../constants';



export function getAllInfodexes() {
  return {
    type: ACTIONS.INFODEX_ALL_GET
  }
};
  

export function updateInfodexes(payload) {
  return { type: ACTIONS.CRYODEX_INFODEX_UPDATE, payload };
};


export function mapInfodexRelationShip(payload) {
  return { type: ACTIONS.CRYODEX_USER_GROUPS_MAP_RELATIONSHIP, payload };
};

export function getInfodexGroups(payload) {
  return { type: ACTIONS.CRYODEX_INFODEX_GROUPS_GET, payload };
}
